import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

/**
 * Reusable empty-state placeholder.
 *
 * Usage:
 *   <EmptyState
 *     icon={BusinessIcon}
 *     title="No subsidiaries found"
 *     description="Create your first subsidiary to organize connectors"
 *     actionLabel="Create Subsidiary"
 *     actionIcon={<AddIcon />}
 *     onAction={() => handleOpenDialog()}
 *   />
 */
export default function EmptyState({
  icon: Icon = InboxOutlinedIcon,
  title = 'No data found',
  description,
  actionLabel,
  actionIcon,
  onAction,
  compact = false,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: compact ? 3 : 5,
        textAlign: 'center',
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 3,
        bgcolor: 'grey.50',
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Icon sx={{ fontSize: compact ? 48 : 64, color: 'text.disabled' }} />
      </Box>
      <Typography
        variant={compact ? 'subtitle1' : 'h6'}
        color="text.secondary"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: actionLabel ? 2.5 : 0, maxWidth: 400, mx: 'auto', lineHeight: 1.6 }}
        >
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button
          variant="contained"
          startIcon={actionIcon}
          onClick={onAction}
          size={compact ? 'small' : 'medium'}
        >
          {actionLabel}
        </Button>
      )}
    </Paper>
  );
}
